import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { PropertyDexie } from 'src/app/models/property.model';
import { CustomValidators } from 'src/app/_helpers/customValidators';
import { DeletePropertyComponent } from './delete-property/delete-property.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-edit-property',
    templateUrl: './edit-property.component.html',
    styleUrls: ['./edit-property.component.css'],
    standalone: true,
    imports:[ReactiveFormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, DeletePropertyComponent]
})
export class EditPropertyComponent implements OnInit {
  dialogRef = inject<MatDialogRef<EditPropertyComponent>>(MatDialogRef);
  property = inject<PropertyDexie>(MAT_DIALOG_DATA);
  dialog = inject(MatDialog);


  editPropertyForm: UntypedFormGroup;

  ngOnInit(): void {
    this.dialogRef.disableClose = true;

    this.editPropertyForm = new UntypedFormGroup(
      {
      'name': new UntypedFormControl(null, CustomValidators.required),
      'notes': new UntypedFormControl(null)
      },);

    this.editPropertyForm.patchValue(this.property);
  }

  openDeleteConfirmationDialog(){
  let confirmationDialog = this.dialog.open(DeletePropertyComponent,{data:this.property.name});

  confirmationDialog.afterClosed().subscribe(result => {
    if(result)
    {
      this.dialogRef.close({deleteProperty: true});
    }
    else
    {
      return;
    }
  })
  }

  submit(){
    Object.assign(this.property, this.editPropertyForm.value);

    this.dialogRef.close(this.property);
  }

}
